import { WalletGroup } from '@/constants/blockchain'

export enum WalletIsDefault {
  True = 0,
  False = 1,
}

export default class Wallet {
  address: string
  eth_balance: string
  group: WalletGroup
  is_default: WalletIsDefault
  time_balance: string
  type: number

  constructor(props: LX.Wallet) {
    Object.assign(this, props)
  }
}
